import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export const SectionHeader = ({ icon: Icon, iconColor = "#2563EB", title, linkTo, testId }) => {
  const { t } = useLanguage();
  return (
    <div className="mb-4 flex items-center justify-between gap-4">
      <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 sm:text-lg">
        {Icon && <Icon className="h-5 w-5" style={{ color: iconColor }} />}
        {t(title)}
      </h2>
      {linkTo && (
        <Link
          to={linkTo}
          data-testid={testId}
          className="flex shrink-0 items-center gap-0.5 text-sm font-medium text-[#2563EB] transition hover:gap-1.5"
        >
          {t("Voir tout")}
          <ChevronRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
};
